import React, { forwardRef } from 'react';
import { ChevronDownIcon } from '@fiverr-private/visuals';
import { translate } from '@fiverr-private/i18n-react';
import { Box } from '@fiverr-private/theme';
import IconButton from '../IconButton';
import { ICON_COLORS } from '../shared/constants';
import type { ChevronButtonProps } from './types';
import { DIRECTIONS } from './constants';

const ChevronButton = forwardRef<HTMLButtonElement, ChevronButtonProps>(
  (
    {
      size = 'md',
      theme = 'dark',
      onClick,
      dataTestId,
      className,
      type,
      ariaLabel,
      disabled,
      shape = 'square',
      chevronDirection = 'down',
      ...rest
    },
    ref
  ) => (
    <IconButton
      ref={ref}
      aria-label={ariaLabel || translate<string>('button.chevronButton.toggle')}
      variant="ghost"
      size={size}
      onClick={onClick}
      data-testid={dataTestId}
      className={className}
      type={type}
      colorScheme={theme === 'light' ? 'white' : undefined}
      disabled={disabled}
      shape={shape}
      {...rest}
    >
      <Box
        transition="0.15s"
        display="flex"
        alignItems="center"
        justifyContent="center"
        transform={DIRECTIONS[chevronDirection]}
      >
        <ChevronDownIcon color={disabled ? undefined : ICON_COLORS[theme]} />
      </Box>
    </IconButton>
  )
);

ChevronButton.displayName = 'ChevronButton';

export default ChevronButton;
